"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._connectToMulticall = void 0;
const contracts_1 = require("@ethersproject/contracts");
const multicallAbi = [
    {
        constant: true,
        inputs: [],
        name: "getCurrentBlockTimestamp",
        outputs: [
            {
                name: "timestamp",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    }
];
const multicallAddress = {
    1: "0xeefba1e63905ef1d7acba5a8513c70307c1ce441",
    3: "0x53c43764255c17bd724f74c4ef150724ac50a3ed",
    4: "0x42ad527de7d4e9d9d011ac45b31d8551f8fe9821",
    5: "0x77dca2c955b15e9de4dbbcf1246b4b85b651e50e",
    42: "0x19DADBd41e73f1528a08BFdAca85899A01d5A6c9",
    80001: "0x19DADBd41e73f1528a08BFdAca85899A01d5A6c9",
    943: "0x51da84FE8744Ff4f7C266691Eea3E5f3E21f4B90" //TO-DO: Shinto, Pulse V4 Multicall contracts
};
const hasMulticall = (chainId) => chainId in multicallAddress;
const _connectToMulticall = (signerOrProvider, chainId) => hasMulticall(chainId)
    ? new contracts_1.Contract(multicallAddress[chainId], multicallAbi, signerOrProvider)
    : undefined;
exports._connectToMulticall = _connectToMulticall;
//# sourceMappingURL=_Multicall.js.map